import script from "./AddAssetRegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAssetRegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./AddAssetRegisterModal.vue?vue&type=style&index=0&id=2f80f358&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f80f358"]])

export default __exports__